


import axios from "axios";
import { toast } from "react-hot-toast";
import {  FaHome, FaLocationArrow, FaMobile, FaPhoneAlt, FaRegUserCircle, FaSignOutAlt, FaUserCheck, FaUsersCog } from "react-icons/fa";
import { Outlet, useNavigate,NavLink } from "react-router-dom";
import { ConvertEnglish } from "../../components/ConterEnglsih";
import { useGStore } from "../../context/Context";
import { FETCHING_ERROR, FETCHING_START, FETCHING_SUCCESS_USER } from "../../state/actionTypes/actionTypes";
import app from "../../../src/Assets/AarmarBill.apk"

const DashboardLayout = () => {
  const {state,dispatch} = useGStore();
  // console.log(state)
  const {role} = state.user;
  const navigation = useNavigate();
  const handleLogout=()=>{
    // console.log("Logout");
    dispatch({type : FETCHING_START})
    axios.get(`https://amar-dish-server.vercel.app/user/logout?number=${state?.user?.userNumber}`).then(res=>{
      // console.log(res.data);
      if(res.data.message === "success" || res.data.message === "Already logout"){
        dispatch({type : FETCHING_SUCCESS_USER , payload : {}})
        toast.success("লগ আউট সফল হয়েছে")
        navigation("/login");
      }
    }).catch(err=>{
      console.log(err);
      dispatch({type : FETCHING_ERROR})
    });
  }
  return (
    <div>
      <div className="drawer drawer-mobile">
        
        <input
          id="dashboard-drawer"
          type="checkbox"
          className="drawer-toggle"
        />
        <div className="drawer-content ">
        
          {/* <!-- Page content here --> */}
          <Outlet></Outlet>
        </div>
     
      <div className="drawer-side text-center" >
          <label htmlFor="dashboard-drawer" className="drawer-overlay"></label>
        
         <ul className="menu gap-5 p-4 w-80 bg-base-100 ">
            {/* <!-- Sidebar content here --> */}
            {/* User ingfo  */}
           <div className="flex flex-col gap-3 shadow-md px-3 py-5 rounded-md">
           <h2 className="flex items-center gap-2 "><span className="text-2xl text-left font-bold">{state?.user?.userName}</span></h2>
           <h2 className="flex items-center gap-2 "><FaPhoneAlt size={22}></FaPhoneAlt> <span>{state?.user?.userNumber}</span></h2>
           <h2 className="flex items-center gap-2 "><FaRegUserCircle size={22}></FaRegUserCircle> <span>{state?.user?.role}</span></h2>
           </div>
           {
            (role === 'collector' || role === 'admin') &&    <li>
            <NavLink to="/" className={({isActive})=> isActive ?" border-b shadow-md bg-[#3ce5e8]" :" border-b shadow-md"} >
            <FaHome size={22}></FaHome>
           <ConvertEnglish english={'Dashboard'} bangla={"ডেসবোর্ড"}></ConvertEnglish></NavLink> 
            </li>
           }
          
            {
             role === 'admin' &&    <li>
            <NavLink to="/area" className={({isActive})=> isActive ?" border-b shadow-md bg-[#3ce5e8]" :" border-b shadow-md"}  >
            <FaLocationArrow size={22}></FaLocationArrow>
            <ConvertEnglish english={'Area'} bangla={"এরিয়া"} /></NavLink>
            </li>
           }
          
            {
            role === 'admin' &&  <li>
            <NavLink to="/collector" className={({isActive})=> isActive ?" border-b shadow-md bg-[#3ce5e8]" :" border-b shadow-md"}  >
            <FaUsersCog size={22}></FaUsersCog>
            <ConvertEnglish english={'Collector'} bangla={"কালেক্টর"} /></NavLink>
            </li>
           }
            
            {
              (role === 'admin' || role === "collector") &&   <li>
            <NavLink to="/customer" className={({isActive})=> isActive ?" border-b shadow-md bg-[#3ce5e8]" :" border-b shadow-md"} >
            <FaUserCheck size={22}></FaUserCheck>
            <ConvertEnglish english={'Customer'} bangla={"গ্রাহক"} /></NavLink>
            </li>
           }
           
         {/* logou button  */}
         <li className="visible lg:hidden  rounded-md mt-20">
            <button className="drawer-button border-b shadow-md ">
           <FaMobile></FaMobile>
           <a href={app}>Download Mobile app</a>
            </button>
            </li>
          <li className="rounded-md">
            <button onClick={handleLogout} className="drawer-button border-b shadow-md lg:mt-20">
            <FaSignOutAlt size={22}></FaSignOutAlt>
            <span className=""><ConvertEnglish className english={'logout'} bangla={"লগ আউট"} /></span>
            </button>
            </li>
          
          
          </ul>
          
      
        </div>
         
      </div>
    </div>
  );
};

export default DashboardLayout;
